<template>
  <div class="panel-in-tab">
    <table-panel ref="tablePanel" class="tablePanel">
      <template v-slot:header-right>
        <div style="hieght: 20px"></div>
      </template>
      <el-table
        :data="tableData"
        ref="tableRef"
        border
        :span-method="objectSpanMethod"
        :height="maxTableHeight + 42"
        v-loading="loading"
      >
        <el-table-column  label="滞销等级"  prop="unsalableLevel"  min-width="100px"  align="center"  show-overflow-tooltip></el-table-column>
        <el-table-column label="分值区间" min-width="120px" align="center">
          <el-table-column label="下限（含）" prop="limitLower" min-width="100"></el-table-column>
          <el-table-column label="上限" prop="limitUpper" min-width="100"></el-table-column>
        </el-table-column>
        <el-table-column label="折扣系数%" prop="discountCoefficient" show-overflow-tooltip width="120"></el-table-column>
        <el-table-column label="调整说明" prop="ruleDesc"  min-width="250px" show-overflow-tooltip></el-table-column>
        <el-table-column label="更新人" prop="updatedBy" min-width="80px"></el-table-column>
        <el-table-column label="更新时间" prop="updatedDate" min-width="160px"></el-table-column>
        <el-table-column label="是否计算折扣" prop="discountAble" min-width="120"></el-table-column>
        <el-table-column label="操作" width="150px" align="center">
          <template slot-scope="scoped">
            <el-link type="primary" :underline="false" @click="edit(scoped.row)">修改</el-link>
            <el-link type="primary" :underline="false" @click="history(scoped.row)">历史记录</el-link>
          </template>
        </el-table-column>
      </el-table>
    </table-panel>
    <edit-dialog :visible.sync="editVisible" v-if="editVisible" :rowData="rowData" @success="onSearch" />
    <history-dialog :visible.sync="historyVisible" v-if="historyVisible" />
  </div>
</template>

<script>
import editDialog from "./components/edit";
import historyDialog from "./components/history";
import tableMixin from "@/utils/tableMixin";
export default {
  mixins: [tableMixin],
  components: { editDialog, historyDialog },
  data() {
    return {
      form: {},
      tableHeight: 0,
      tableData: [],
      editVisible: false,
      historyVisible: false,
      rowData: {},
      loading: false,
      spanIndex: 0,
      spanArr: [],
    };
  },
  computed: {},
  mounted() {
    this.onSearch();
  },
  methods: {
    onSearch() {
      this.init();
    },
    async init() {
      this.loading = true;
      this.$q.newProduct
        .configLevelInfoList()
        .then((res) => {
          this.tableData = res.data;
          this.computeSpanData(res.data);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },
    // 重置
    reset() {
      this.form = {};
      this.init();
    },
    // 修改 弹出dialog
    edit(row) {
      this.rowData = JSON.parse(JSON.stringify(this.tableData));
      this.editVisible = true;
    },
    history(row) {
      this.rowData = row;
      this.historyVisible = true;
    },
    // 遍历表格数据，计算合并行数据
    computeSpanData(list) {
      this.spanArr = [];
      list.forEach((item, index) => {
        this.recordSpanData(index, list);
      });
    },
    // 计算每一行的合并行数据
    recordSpanData(index, data) {
      if (index === 0) {
        this.spanArr.push(1)
        this.spanIndex = 0
      } else {
        // 判断当前元素与上一个元素是否相同
        if (data[index].userId === data[index - 1].userId) {
          this.spanArr[this.spanIndex] += 1
          this.spanArr.push(0)
        } else {
          this.spanArr.push(1)
          this.spanIndex = index
        }
      }
    },
    objectSpanMethod({ rowIndex, columnIndex }) {
      if (columnIndex > 3) {
        return {
          rowspan: this.spanArr[rowIndex],
          colspan: 1
        };
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.panel-in-tab
  >>> .search-outer>div
    padding 0

>>> .tablePanel .el-table .cell {
  white-space: pre-line;
}
</style>
